import React, { createContext, useContext, useEffect, useState } from "react";
import myImage from "../Component/Assets/Logo/NYC-Logo.png"
const ClientInformationContext = createContext();

export const ClientInformationProvider = ({ children }) => {
  const [categoryData, setCategoryData] = useState([])
  const [customerTypeData, setCustomerTypeData] = useState([])
  const tokenData = localStorage.getItem('auth-token');
  const sessionNewEmailId = sessionStorage.getItem("NewUserEmail")
  // Amit 13-08-2024
  const [userList, setUserList] = useState([]);
  useEffect(() => {
    const fetchUserList = async () => {
      if (!tokenData) return; // Ensure tokenData is truthy before fetching
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/optionsetData/get-user-list`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ tokenData }),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch customer type options');
        }

        try {
          const data = await response.json();
          console.log("Fetched user list data:", data);
          // Check if 'data' is an array and contains the correct structure
          if (Array.isArray(data)) {
            var none_of_above_user = data.find(item => item.label === "Fabiana Iloski");
            if (none_of_above_user) {
              sessionStorage.setItem('none_of_above_user', none_of_above_user.value);
            } else {
              console.warn("User 'Fabiana Iloski' not found in the user list.");
            }
            setUserList(data);
          } else {
            throw new Error("Unexpected data format. Expected an array.");
          }
        } catch (error) {
          console.log("Error:", error);
        }
      } catch (error) {
        console.log("Erron", error)
      }
    };

    fetchUserList();
  }, [tokenData]);
  useEffect(() => {
    const fetchCustomerTypeOptionSet = async () => {
      if (!tokenData) return; // Ensure tokenData is truthy before fetching
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/optionsetData/optionCustomerCategory`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ tokenData }),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch customer type options');
        }

        const data = await response.json();
        setCustomerTypeData(data); // Assuming you have a state setter for customerTypeData
      } catch (error) {
        console.log("Erron", error)
      }
    };

    fetchCustomerTypeOptionSet();
  }, [tokenData]);

  console.log("setCustomerTypeData", customerTypeData, 81)

  useEffect(() => {
    const fetchCategoryOptionSet = async () => {
      if (!tokenData) return; // Ensure tokenData is truthy before fetching
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/optionsetData/optionCategory`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ tokenData }),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch category options');
        }

        const data = await response.json();
        setCategoryData(data); // Assuming you have a state setter for categoryData
      } catch (error) {
        console.log("Erron", error)
      }
    };

    fetchCategoryOptionSet();
  }, [tokenData]);

  console.log("setCategoryData", categoryData)


  return (
    <ClientInformationContext.Provider value={{ customerTypeData, categoryData, tokenData, myImage, sessionNewEmailId, userList }}>
      {children}
    </ClientInformationContext.Provider>
  );

}

export const useClientInformationContext = () => {
  const context = useContext(ClientInformationContext);
  if (context === undefined) {
    throw new Error('useClientInformationContext must be used within a ClientInformationProvider');
  }
  return context;
};

